import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { LeadSource } from "services/redux/sales/corporate/leadDetails/action";
import {
  pocSiteType,
  pocSubSiteType,
  pocType,
} from "services/redux/sales/corporate/pocDetails/action";
import {
  leadCategories,
  getSupplyDropDown,
} from "services/redux/sales/corporate/categoryDetails/action";
import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";
import {
  documentUploadUrl,
  imageUploadUrl,
  videoUploadUrl,
} from "services/redux/fileUpload/action";
import Supply from "./supply";
import { createSupplyLead } from "services/redux/sales/corporate/action";
import { getCurrentLocation } from "services/redux/sales/currentLocation/action";
import { excelUploadUrl } from "services/redux/fileUpload/action";
import { BulkUploadLead, getSampleFileLead } from "services/redux/sales/importLead/action";

const mapStateToProps = (state) => ({
  sourceData: state.LeadDetailsReducer.LeadSources,
  pocTypeData: state.pocTypesReducer.pocTypeData,
  pocSiteTypeData: state.pocTypesReducer.pocSiteTypeData,
  pocSubSiteTypeData: state.pocTypesReducer.pocSubSiteTypeData,
  leadCategory: state.categoryDetlReducer.leadCategory,
  supDropDownData: state.categoryDetlReducer.supDropDownData,
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  latlng: state.currentLocationReducer.latlng,
  toastMsg: state.toastReducer,
  sampleData: state.importReducer.sampleData,
  documentUrlData: state.fileUploadReducer.documentUrlData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LeadSource,
      pocType,
      leadCategories,
      locationCity,
      locationZone,
      locationArea,
      locationType,
      locationPinCode,
      locationState,
      createSupplyLead,
      pocSiteType,
      pocSubSiteType,
      getSupplyDropDown,
      getCurrentLocation,
      excelUploadUrl,
      BulkUploadLead,
      getSampleFileLead,
      documentUploadUrl
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Supply);
